import { MainLayout } from "@/novus/layouts/MainLayout"
import { joinOrganizationSigninPath } from "@/novus/novus-paths"
import { useQuery } from "@apollo/client"
import React from "react"
import { Link, useParams } from "react-router-dom"
import invariant from "tiny-invariant"
import { getOrganizationQuery } from "./api"
import CreateAccountForm from "../components/CreateAccountForm"
import { H1 } from "@/components/ui/headings"

export const OrganizationSignupScreen = () => {
  const { memberInviteToken } = useParams<{ memberInviteToken: string }>()
  const { data, loading, error } = useQuery(getOrganizationQuery, {
    variables: { memberInviteToken },
  })
  const { organization } = data || {}

  invariant(memberInviteToken)

  if (loading)
    return (
      <MainLayout showLogo={true}>
        <div>Loading...</div>
      </MainLayout>
    )

  if (error)
    return (
      <MainLayout showLogo={true}>
        <div>Error: {error.message}</div>
      </MainLayout>
    )

  if (!organization?.name)
    return (
      <MainLayout showLogo={true}>
        <H1>Welcome to Hadley!</H1>
        <div className="my-10">
          <p className="mb-2">This link appears to be invalid.</p>
          <p>Please reach out to your Hadley admin for help.</p>
        </div>
      </MainLayout>
    )

  return (
    <MainLayout showLogo={true}>
      <H1>Create Your Hadley Account</H1>

      <h2 className="text-lg md:text-2xl mb-6">
        {organization.name} has invited you to join their organization.
      </h2>
      <CreateAccountForm organizationMemberInviteToken={memberInviteToken} />
    </MainLayout>
  )
}
